import GoogleOneTap from './GoogleOneTap';

export default GoogleOneTap;
